<template>
	<div class="matters_list">
    <el-form ref="baseForm" :rules="rules" :model="fromData">
    <search-box @subSearch="subSearch" :fromData="fromData">
      <el-form-item class="item" label="生产订单号：" prop="productOrderNo">
        <el-input  v-model="fromData.searchCriteria.productOrderNo" placeholder="请输入生产订单号"></el-input>
      </el-form-item>
    </search-box>
    </el-form>

    <tab-list
    setHeadBtn
    :tabCheckbox = false
    ref="multipleTable"
    tabHeight="310"
    :selectedList="selectedList"
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="matters-issueBackflush-list"
    @getSelect="getSelect"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata">
    </tab-list> 
	</div>
</template>
<script>
import {saleOutStock} from 'api/stock.js';
import tabList from 'components/table/list.vue';
import { issueBackflush } from "api/business.js";

import searchBox from 'components/common/search.vue';
export default{
  components:{
    tabList,searchBox
  },
  props:{
  	//已选列表,未添加到数据库
  	selectedList:Array,
    searchCriteria:Object,//搜索条件
  },
	data(){
		return{
    listArr:[],//列表
			sdata:{},
      rules: {
        productOrderNo:[{message: "",trigger: "blur"}],
      },
			tabColumns:[                
        { field: 'productOrderNo', title: '生产订单号',"sortable":true },
        { field: 'inventoryDesc', title: '库存地'},
        { field: 'materialDesc', title: '物料描述'},
        { field: 'planFactoryDesc', title: '计划工厂'},
        { field: 'createDate', title: '单据日期'}
			
			],//表头字段
			isDelList:false,//是否显示已删除的
			total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:20,//每页显示的数量,
				searchCriteria:{}
			}
		}
	},
	watch:{
		//监听选择的变化
    selectedList:{
      handler:function(newVal){
        if(this.selectedList.length != newVal.length){
          this.getList();
        }
      },
      deep:true
    },
    fromData:{
      handler:function(){
        console.log(11,'条件改变');
        this.getList();
      },
      deep:true
    }
	},
	created(){
		this.getList();
	},
	methods:{
    //取消选择
    cancelSelect(){
      this.$refs.multipleTable.cancelSelect();
    },
    //获取已选
    getSelect(res){
      this.$emit('getSelect',res);
    },
    //选中数据
    selectSdata(data){
      this.sdata = data;
      this.$emit('selectSdata',data);
    },
		//初始化需要获取的数据 
		async getList(){
      console.log(this.fromData)
      let res = await this.$post(issueBackflush.list,this.fromData);
        console.log(res)
        if(res.status && res.data){
        res.data.list.map(item=>{
          return item.selectId = item.productOrderNo
        });
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      }else{
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
        this.$message.error(res.errorMsg);
        }
		}, 
		//当前页码改变
		currentChange(currentPage){
			this.fromData.page = currentPage;
			this.getList();
		},
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
		//搜索按钮
		subSearch(){
			this.fromData.page = 1;
			this.getList();
		},
		handleSelectChange(item,key){
			if(item.isLock) return false;
			if(item.isChecked){
				item.isChecked = false;
				this.selectList.splice(key,1);
			}else{
				item.isChecked = true;
				this.selectList.push(item);
			}
		}
	}
}
</script>

<style>
</style>
